import {getToken} from './authService';

// const axios = require('axios').default;
import * as axios from 'axios';
const FormData = require('form-data');

interface API_PARAMS {
    path: string;
    method?: string;
    data?: any;
    kind?: string;
}

const call = async (params: API_PARAMS,type?:string) => {
    const {path, method = 'GET', data = {}, kind = 'raw'} = params;

    let form;
    const token = getToken();
    const extraConfig: any = {
        headers: {}
    };
    if (token) {
        extraConfig.headers.Authorization = token;
    }
    if (method === 'POST'|| method === 'PUT') {
        if(kind === 'raw' ){
            form=data
        }else{
            form = new FormData();

            const dataKeys: any = Object.keys(data);
            for (const key of dataKeys) {
                if (data[key] !== undefined && data[key] !== null) {
                    form.append(key, data[key]);
                }
            }   
            extraConfig.headers['Content-Type'] = 'multipart/form-data';
        }
    
        // console.log(form);
        extraConfig.data = form;
    } else {
        extraConfig.params = data;
    }
    let url = `${process.env.REACT_APP_API_BASE_URL}${path}`;
    
   
    let response: any;
    try {
        response = await axios.default({
            method,
            url,
            ...extraConfig
        });
    } catch (e:any) {
        if (e.isAxiosError) {
            console.log(e);
            throw e.response && e.response.data && e.response.data.message
                ? e.response.data.message
                : e.message;
        }
        
        return e;
    }

    if ([200, 201].indexOf(response.status) === -1) {
        throw new Error(response.statusText).message;
    }
    
    return response.data;
};

export const callWithErrorResponse = async (params: API_PARAMS,type?:string) => {
    const {path, method = 'GET', data = {}} = params;

    let form;
    const token = getToken();
    const extraConfig: any = {
        headers: {}
    };
    if (token) {
        extraConfig.headers.Authorization = token;

    }
    if (method === 'POST'|| method === 'PUT') {
        form = new FormData();

        const dataKeys: any = Object.keys(data);
        for (const key of dataKeys) {
            if (data[key] !== undefined) {
                form.append(key, data[key]);
            }
        }

        extraConfig.headers['Content-Type'] = 'multipart/form-data';
        // console.log(form);
        extraConfig.data = form;
    } else {
        extraConfig.params = data;
    }
    let url = '';
    switch(type){
        case 'sdd' : url = `${process.env.REACT_APP_SDD_API_BASE_URL}${path}`;
        break;
        case 'auth' : url = `${process.env.REACT_APP_AUTH_API_BASE_URL}${path}`;
        break;
        case 'supplier' : url = `${process.env.REACT_APP_SUPPLIER_API_BASE_URL}${path}`;
        break;
        case 'public' : url = `${process.env.REACT_APP_PUBLIC_API_BASE_URL}${path}`;
        break;
        case 'captain' : url = `${process.env.REACT_APP_CAPTAIN_API_BASE_URL}${path}`;
        break;
        case 'finance' : url = `${process.env.REACT_APP_FINANCE_API_BASE_URL}${path}`;
        break;
        default : url = `${process.env.REACT_APP_SDD_API_BASE_URL}${path}`;
        break;
    }
   
    let response: any;
    try {
        response = await axios.default({
            method,
            url,
            ...extraConfig
        });
    } catch (e:any) {
        console.log("check hsbfvhjdbfjhv: ",e.response)
        if (e.isAxiosError) {
            console.log(e);
            throw e.response && e.response.data && e.response.data.message
                ? e.response.data.message
                : e.message;
        }
        
        return e.response;
    }

    if ([200, 201].indexOf(response.status) === -1) {
        throw new Error(response.statusText).message;
    }
    
    return response.data;
};

/*const call = async (params: API_PARAMS) => {
    const {path, method = 'GET', data = {}} = params;

    const xhr = new XMLHttpRequest();


    const formData: FormData = new FormData();

    const dataKeys: any = Object.keys(data);
    for (const key of dataKeys) {
        if (data[key] !== undefined) {
            formData.append(key, data[key]);
        }
    }



    const url = `${process.env.REACT_APP_API_BASE_URL}${path}`;
    let response: any;
    try {
        response = await new Promise(resolve => {
            xhr.open(method, url);
            xhr.setRequestHeader('Content-type', 'application/form-data');
            xhr.addEventListener("readystatechange", function () {
                if (this.readyState === 4) {
                    resolve({
                        status: this.status,
                        statusText: this.responseText,
                        json: () => {
                            return JSON.parse(this.responseText)
                        }
                    });
                }
            });
            xhr.send(formData);
        });

    } catch (e) {
        return e;
    }
    if ([200, 201].indexOf(response.status) === -1) {
        throw new Error(response.statusText).message;
    }
    return response.json();

};*/

/*const call = async (params: API_PARAMS) => {
    const {path, method = 'GET', data = {}} = params;

    const headers = new Headers();
    headers.append("Content-Type", "application/x-www-form-urlencoded");

    const urlencoded = new URLSearchParams();

    const requestOptions: any = {
        method: method,
        headers: headers
    };

    if (method === 'POST') {
        const dataKeys: any = Object.keys(data);
        for (const key of dataKeys) {
            if (data[key] !== undefined) {
                urlencoded.append(key, data[key]);
            }
        }

        requestOptions.body = urlencoded;
    } else if (method === 'GET') {
        /!*const dataKeys: any = Object.keys(data);
        for (const key of dataKeys) {
            if (data[key] !== undefined) {
                urlencoded.append(key, data[key]);
            }
        }

        requestOptions.body = urlencoded;*!/
    }

    const url = `${process.env.REACT_APP_API_BASE_URL}${path}`;
    let response;
    try {
        response = await fetch(
            url,
            requestOptions
        );
    } catch (e) {
        return e;
    }
    if ([200, 201].indexOf(response.status) === -1) {
        throw new Error(response.statusText).message;
    }
    return await response.json();

};*/

export default call;